var _g, _circle, _circle2, _path, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 169,
    viewBox: "0 0 173 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.03,
    filter: "url(#filter0_f_2118_7290)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.1421,
    cy: 89.1294,
    r: 77.3413,
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5679,
    cy: 78.3354,
    r: 77.3413,
    fill: "url(#paint0_linear_2118_7290)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5803,
    cy: 78.3357,
    r: 59.7361,
    transform: "rotate(90 77.5803 78.3357)",
    fill: "url(#paint1_linear_2118_7290)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M109.52 7.24316C125.168 14.5823 137.954 27.0093 145.75 42.3937L41.8068 146.337C26.4224 138.541 13.9953 125.755 6.65625 110.107L109.52 7.24316Z",
    fill: "url(#paint2_linear_2118_7290)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2118_7290)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5352 48.3135H58.7931V108.356H47.5352V48.3135ZM107.582 61.4483V72.7062L73.8081 72.7062V61.4483L107.582 61.4483ZM107.582 95.2214V83.9635H73.8081V95.2214H107.582Z",
    fill: "#F08D02"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2118_7290)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.769 82.8096C130.185 82.8096 121.605 91.3894 121.605 101.973V120.445C121.605 131.029 130.185 139.609 140.769 139.609C151.353 139.609 159.933 131.029 159.933 120.445V101.973C159.933 91.3894 151.353 82.8096 140.769 82.8096ZM140.769 89.1259C133.953 89.1259 128.427 94.6519 128.427 101.469V119.94C128.427 126.757 133.953 132.283 140.769 132.283C147.586 132.283 153.112 126.757 153.112 119.94V101.469C153.112 94.6519 147.586 89.1259 140.769 89.1259Z",
    fill: "#848395"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.594,
    y: 111.209,
    width: 52.3465,
    height: 37.9964,
    rx: 10,
    fill: "#5A5851"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.594 138.552L151.431 111.209H160.94C164.254 111.209 166.94 113.895 166.94 117.209V129.17L142.83 149.205H120.594C117.28 149.205 114.594 146.519 114.594 143.205V138.552Z",
    fill: "url(#paint3_linear_2118_7290)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2118_7290",
    x: 5.80078,
    y: 9.78809,
    width: 158.684,
    height: 158.683,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2118_7290"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2118_7290",
    x: 47.5352,
    y: 48.3135,
    width: 60.0469,
    height: 60.042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2118_7290"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2118_7290",
    x: 108.594,
    y: 82.8096,
    width: 64.3477,
    height: 78.3955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2118_7290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2118_7290",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2118_7290",
    x1: 26.2427,
    y1: 13.2492,
    x2: 100.755,
    y2: 160.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEAC06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2118_7290",
    x1: 37.9383,
    y1: 28.065,
    x2: 95.4894,
    y2: 141.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEAC06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2118_7290",
    x1: 76.203,
    y1: 7.24316,
    x2: 76.203,
    y2: 146.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2118_7290",
    x1: 140.767,
    y1: 111.209,
    x2: 140.767,
    y2: 149.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinLock);
export default __webpack_public_path__ + "static/media/coin_lock.9919baa7b2848025d93ce330e7bca010.svg";
export { ForwardRef as ReactComponent };